import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import { ENTITY_DESER, Entity } from "./entity"

export enum EntityAuthorityLevel {
  ADMINISTRATOR = "administrator",
}

export class EntityAuthority extends RestResource {
  authorityLevel: EntityAuthorityLevel = EntityAuthorityLevel.ADMINISTRATOR
  entity = new Entity()
  ownerOfRecord = false
}

export const ENTITY_AUTHORITY_DESER: SchemaDeSer<EntityAuthority> =
  new SchemaDeSerBuilder(EntityAuthority)
    .ofString("authorityLevel")
    .ofBoolean("ownerOfRecord")
    .ofNested("entity", ENTITY_DESER, Entity)
    .toDeSer()
